import { CircularProgress } from "@material-ui/core";
import { Suspense } from "react";

type CircularSuspenseProps = {};
const CircularSuspense: React.FC<CircularSuspenseProps> = ({ children }) => {
  return <Suspense fallback={<CircularProgress />}>{children}</Suspense>;
};
export default CircularSuspense;
